<template>
    <Breadcrumbs :here="'差分概要（全体）'"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large2}">支店ごとの配布記録データ差分概要</div>
    </div>
    <div class="row my-2">
        <div class="container col-sm col-md-8">
            <div class="row justify-content-end mt-2">
                <div class="col-4">更新日時：{{ updatedDTString() }}</div>
            </div>
            <div class="row table-header-row">
                <div class="col">支店名</div>
                <div class="col">差分概要</div>
            </div>
            <div v-for="bEntity in recordDiffSummary.entities"
                 :key="bEntity.vForKey"
                 class="row summary-row">
                <div class="col summary-col align-self-center">
                    <a v-if="bEntity.hasDiff"
                       @click.prevent="onClickBranchSummary(bEntity.branch)"
                       href="#">{{ bEntity.branch }}</a>
                    <template v-else>{{ bEntity.branch }}</template>
                </div>
                <div class="col summary-col align-self-center">
                    <p class="diff-text"
                       :class="{'added': bEntity.added > 0}">追加：{{ bEntity.added }}</p>
                    <p class="diff-text"
                       :class="{'changed': bEntity.changed > 0}">変更：{{ bEntity.changed }}</p>
                    <p class="diff-text"
                       :class="{'deleted': bEntity.deleted > 0}">削除：{{ bEntity.deleted }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {backendApi} from "@/utils/backend-api";
import {datetimeFormat, subPaths} from "@/utils/consts";
import {useRouter} from "vue-router";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {PostingRecordAllDiffSummary} from "@/data-models/posting-record-all-diff-summary";
import {format} from "date-fns";

export default defineComponent({
    name: "PostingRecordsAllDiff",
    components: {Breadcrumbs},
    setup() {

        const recordDiffSummary = ref<PostingRecordAllDiffSummary>(new PostingRecordAllDiffSummary())

        const router = useRouter()

        onMounted(async () => {
            const diffResp = await backendApi.inquirePostingRecordsAllDiff()
            console.log(diffResp)

            if (diffResp.isAuthorized) {

                recordDiffSummary.value = PostingRecordAllDiffSummary.fromJson(diffResp.value)
                console.log(recordDiffSummary.value)

            } else {
                await router.push(subPaths.LOGIN)
            }

            loadingOverlayStateStore.commit("fadeout")
        })

        const updatedDTString = (): string => {
            return format(recordDiffSummary.value.updatedAt as Date, datetimeFormat)
        }

        const onClickBranchSummary = (branchName: string) => {

            loadingOverlayStateStore.commit("switchLoadingState", {
                show: true,
                message: `${branchName}の差分概要に移動中…`
            })

            router.push({
                path: subPaths.POSTING_RECORDS_BRANCH_DIFF,
                query: {
                    name: branchName
                }
            })
        }

        return {
            FontSizes,
            ancestries: [
                {
                    name: "ホーム",
                    pathObj: subPaths.HOME
                }
            ],
            recordDiffSummary,
            updatedDTString,
            onClickBranchSummary,
        }
    }
})
</script>

<style scoped lang="scss">
.table-header-row {
    background-color: whitesmoke;
    height: 40px;
    border: 2px solid gray;
    line-height: 40px;
    font-weight: bold;

    div:first-child {
        border-right: 1px solid gray;
    }
}

.summary-row {
    border: 1px solid gray;
    border-top: none;

    .summary-col {

        &:last-child {
            border-left: 1px solid gray;
        }

        .diff-text {
            height: 30px;
            line-height: 30px;
            margin: 2px;
        }

        .added {
            background-color: #6affbb;
            color: #006839;
        }

        .changed {
            background-color: #FFE2BB;
            color: darkgoldenrod;
        }

        .deleted {
            background-color: #FFBBBB;
            color: red;
        }
    }


}

</style>